module.exports = __webpack_public_path__ + "static-m/img/bianji.bfeca4ca.png";